import React from 'react'

import { Table, Form } from '_zari/core'

import { SelectCentroCosto, SelectCentroCostoNivel2 } from 'sharedComponents/select'

import ActualizarComentarioModal from './modals/actualizarComentario'

const FilaDetalleTemplate = ({ index, row, actualizarFilaHandler, actualizarComentarioHandler, eliminarFilaHandler, flagTaller, tipoOperacion, esSalida }) => {
  const [_idCentroCostoNivel1, setIdCentroCostoNivel1] = React.useState(row._idCentroCostoNivel1 || '')
  const [_idCentroCostoNivel2, setIdCentroCostoNivel2] = React.useState(row._idCentroCostoNivel2 || '')
  const [cantidad, setCantidad] = React.useState(row.cantidad)
  const [precio, setPrecio] = React.useState(row.precio)
  const [mostrarActualizarComentarioModal, setMostrarActualizarComentarioModal] = React.useState(false)

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = true
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      const numCantidad = parseFloat(cantidad)
      if (numCantidad === 0 || (!cantidad && cantidad !== 0)) {
        if (window.confirm('La cantidad es 0. ¿Desea eliminar este ítem?')) {
          eliminarFilaHandler(row._idFila)
          return
        }
        setCantidad(row.cantidad || '1')
        return
      }

      __focusCantidad = false
      __focusPrecio = !esSalida
      saltarCampo = true
      saltarFila = esSalida
    }
    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      _idCentroCostoNivel1,
      _idCentroCostoNivel2,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const keyUpPrecioHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = false
    let __focusPrecio = true
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusPrecio = false
      saltarCampo = true
      saltarFila = false
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      _idCentroCostoNivel1,
      _idCentroCostoNivel2,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownPrecioHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const blurCentroCostoNivel1 = e => {
    const keyCode = e.keyCode

    let __focusCantidad = false
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusPrecio = false
      saltarCampo = true
      saltarFila = tipoOperacion !== '27'
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      _idCentroCostoNivel1,
      _idCentroCostoNivel2,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const blurCentroCostoNivel2 = e => {
    const keyCode = e.keyCode

    let __focusCantidad = false
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusPrecio = false
      saltarCampo = true
      saltarFila = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      _idCentroCostoNivel1,
      _idCentroCostoNivel2,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const clickActualizarComentarioHandler = () => {
    window.setTimeout(() => {
      setMostrarActualizarComentarioModal(true)
    }, 150)
  }

  const actualizarComentarioInnerHandler = ({ comentario }) => {
    setMostrarActualizarComentarioModal(false)
    actualizarComentarioHandler({
      ...row,
      comentario
    })
  }

  const clickEliminarFilaHandler = () => {
    window.setTimeout(() => {
      eliminarFilaHandler(row._idFila)
    }, 150)
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (row.__filaActiva && row.__focusCantidad) {
      window.setTimeout(() => {
        inputCantidadRef.current.select()
      }, 250)
    }
  }, [row.__filaActiva, row.__focusCantidad])

  return (
    <>
      <tr>
        <td>{parseFloat(index) + 1}</td>
        <td>{row.codigoProducto || '--'}</td>
        <td>
          {row.nombreProducto || '--'} - {row.nombreUnidadDeMedida || '--'}
        </td>
        <td>
          <Form.InputText
            ref={inputCantidadRef}
            placeholder='0'
            value={cantidad}
            onChange={e => setCantidad(e.target.value)}
            onKeyUp={keyUpCantidadHandler}
            onKeyDown={keyDownCantidadHandler}
          />
        </td>
        {tipoOperacion !== '27' && !esSalida && (
          <>
            <td>
              <Form.InputText
                placeholder='0'
                value={precio}
                onChange={e => { if (!row.precioNoEditable) setPrecio(e.target.value) }}
                onKeyUp={row.precioNoEditable ? undefined : keyUpPrecioHandler}
                onKeyDown={row.precioNoEditable ? undefined : keyDownPrecioHandler}
                onFocus={e => e.currentTarget.select()}
                autoFocus={row.__filaActiva && row.__focusPrecio}
                disabled={row.precioNoEditable}
              />
            </td>
            <td>{row.subTotal || '--'}</td>
          </>
        )}
        {tipoOperacion === '27' && (
          <>
            <td>
              <SelectCentroCosto
                id={`select-det-centroCostoNivel1-${index}`}
                name={`select-det-centroCostoNivel1-${index}`}
                nivel={1}
                value={_idCentroCostoNivel1}
                onChange={e => setIdCentroCostoNivel1(e.target.value)}
                onBlur={blurCentroCostoNivel1}
              />
            </td>

            <td>
              {_idCentroCostoNivel1 && (
                <>
                  <SelectCentroCostoNivel2
                    id={`select-det-centroCostoNivel2-${index}`}
                    name={`select-det-centroCostoNivel2-${index}`}
                    value={_idCentroCostoNivel2}
                    onChange={e => setIdCentroCostoNivel2(e.target.value)}
                    onBlur={blurCentroCostoNivel2}
                    idNodoPadre={_idCentroCostoNivel1}
                  />
                </>
              )}
            </td>
          </>
        )}

        <td>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='comentario' handleClose={handleClose} onClick={clickActualizarComentarioHandler}>
                Comentario
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={clickEliminarFilaHandler}>
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </td>
      </tr>
      {mostrarActualizarComentarioModal && (
        <ActualizarComentarioModal
          handleClose={e => setMostrarActualizarComentarioModal(false)}
          show={mostrarActualizarComentarioModal}
          modalData={row}
          actualizarComentarioHandler={actualizarComentarioInnerHandler}
        />
      )}
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
